export const addGlobalActivityEventListener = handleEvent => {
  window.addEventListener('click', handleEvent);
  window.addEventListener('keydown', handleEvent);
};

export const removeGlobalActivityEventListener = handleEvent => {
  window.removeEventListener('click', handleEvent);
  window.removeEventListener('keydown', handleEvent);
};
